<!-- Capture content in a template reference -->
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>

<!-- Button element -->
<button
  *ngIf="elementType === 'button'"
  [type]="type"
  class="btn"
  [ngClass]="{
    'btn--variant-filled': variant === 'filled',
    'btn--variant-outline': variant === 'outline',
    'btn--variant-invisible': variant === 'invisible',
    'btn--color-primary': color === 'primary',
    'btn--color-secondary': color === 'secondary',
    'btn--color-error': color === 'error',
    'btn--color-light': color === 'light',
    'btn--size-sm': size === 'sm',
    'btn--size-lg': size === 'lg',
    'btn--size-xl': size === 'xl',
    'btn--block': block,
    'btn--icon': icon,
    'btn--square': square
  }"
  [attr.aria-label]="ariaLabel"
  [disabled]="disabled"
  (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</button>

<!-- Anchor element -->
<a
  *ngIf="elementType === 'a'"
  [href]="href"
  [attr.target]="target"
  [attr.rel]="rel"
  class="btn"
  [ngClass]="{
    'btn--variant-filled': variant === 'filled',
    'btn--variant-outline': variant === 'outline',
    'btn--variant-invisible': variant === 'invisible',
    'btn--color-primary': color === 'primary',
    'btn--color-secondary': color === 'secondary',
    'btn--color-error': color === 'error',
    'btn--color-light': color === 'light',
    'btn--size-sm': size === 'sm',
    'btn--size-lg': size === 'lg',
    'btn--size-xl': size === 'xl',
    'btn--block': block,
    'btn--icon': icon,
    'btn--square': square,
    'btn--disabled': disabled
  }"
  [attr.aria-label]="ariaLabel"
  (click)="!disabled && onClick($event)">
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</a>

<!-- Router link element -->
<a
  *ngIf="elementType === 'router'"
  [routerLink]="routerLink"
  [queryParamsHandling]="queryParamsHandling"
  [attr.target]="target"
  [attr.rel]="rel"
  class="btn"
  [ngClass]="{
    'btn--variant-filled': variant === 'filled',
    'btn--variant-outline': variant === 'outline',
    'btn--variant-invisible': variant === 'invisible',
    'btn--color-primary': color === 'primary',
    'btn--color-secondary': color === 'secondary',
    'btn--color-error': color === 'error',
    'btn--color-light': color === 'light',
    'btn--size-sm': size === 'sm',
    'btn--size-lg': size === 'lg',
    'btn--size-xl': size === 'xl',
    'btn--block': block,
    'btn--icon': icon,
    'btn--square': square,
    'btn--disabled': disabled
  }"
  [attr.aria-label]="ariaLabel"
  (click)="!disabled && onClick($event)">
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</a>
